export interface FAQQuestion {
  id: string;
  question: string;
  answer: string;
  structuredData?: boolean;
  link?: { href: string; label: string };
}

export interface FAQCategory {
  id: string;
  title: string;
  questions: FAQQuestion[];
}

/** Visible FAQ content shared with the page's structured data. */
export const FAQ_CATEGORIES: FAQCategory[] = [
  {
    id: 'general',
    title: 'Общие вопросы',
    questions: [
      {
        id: 'work-hours',
        question: 'В какие часы осуществляются прием и доставка заказов?',
        answer: 'Принимаем и доставляем заказы ежедневно с 11:00 до 22:00.',
      },
      {
        id: 'min-order',
        question: 'Существует ли минимальная сумма заказа?',
        answer:
          'Минимальная сумма заказа зависит от адреса и зоны доставки. Укажите улицу и дом на странице «Доставка» или при оформлении заказа — покажем точную сумму для вашего адреса.',
        link: { href: '/delivery', label: 'Проверить адрес' },
      },
      {
        id: 'min-order-delivery',
        question: 'Есть ли минимальная сумма заказа для доставки?',
        answer:
          'Да. Минимальная сумма заказа для доставки зависит от зоны. Точный минимум появится после проверки вашего адреса на странице «Доставка» или при оформлении заказа.',
        link: { href: '/delivery', label: 'Проверить адрес' },
      },
      {
        id: 'order-options',
        question: 'Какие варианты оформления заказа существуют?',
        answer:
          'Все заказы оформляются online на нашем сайте или в приложении. Мы не принимаем заказы по телефону, в соцсетях и мессенджерах. Оплата наличными или банковскими переводами также не предусмотрена.',
        link: { href: '/#menu', label: 'Перейти к меню' },
      },
      {
        id: 'after-order',
        question: 'Заказ оформлен и оплачен, что делать дальше?',
        answer:
          'Если вы оформили заказ и получили уведомление о том, что заказ принят, то просто наберитесь терпения. Совсем скоро мы привезем ваши роллы. Если при оформлении заказа вы выбрали функцию подтверждения заказа, ожидайте звонок нашего оператора с дальнейшими инструкциями.\n\nЕсть срочный вопрос? Звоните по номеру телефона: 8 (863) 333-50-50.',
        link: { href: 'tel:+78633335050', label: '8 (863) 333-50-50' },
      },
    ],
  },
  {
    id: 'delivery',
    title: 'Доставка',
    questions: [
      {
        id: 'delivery-time',
        question: 'Как скоро я получу свой заказ?',
        answer:
          'Ориентировочное время зависит от адреса и зоны доставки и появится после проверки адреса. Время считаем с подтверждения заказа; на него также влияют загрузка кухни, погода и движение на дорогах. Мы очень стараемся приехать как можно быстрее!',
        link: { href: '/delivery', label: 'Узнать время доставки' },
      },
      {
        id: 'delivery-areas',
        question: 'Как понять, включен ли мой адрес в зону доставки?',
        answer:
          'Пожалуйста, ознакомьтесь с картой доставки на нашем сайте в разделе «Доставка» или проверьте адрес при оформлении заказа в приложении.',
        link: { href: '/delivery', label: 'Карта и проверка адреса' },
      },
      {
        id: 'courier-contact',
        question: 'Как я могу связаться с курьером?',
        answer:
          'Обмен контактными данными с курьерами не предусмотрен внутренними регламентами компании.\n\nЕсли у вас есть срочный вопрос, пожалуйста, свяжитесь с нашим call-центром: 8 (863) 333-50-50.',
        link: { href: 'tel:+78633335050', label: '8 (863) 333-50-50' },
      },
      {
        id: 'yandex-courier',
        question: 'Почему приехал не ваш курьер?',
        answer:
          'Мы искренне считаем, что залог качественного сервиса — умение делегировать. Именно поэтому доверяем доставку ваших заказов нашим партнерам — специализированным службам доставки. Мы берем на себя все расходы, связанные с доставкой, а также направляем вам уведомление для отслеживания передвижений вашего заказа.',
      },
      {
        id: 'late-delivery',
        question: 'Курьер опаздывает, что делать?',
        answer:
          'Мы очень стараемся, чтобы наши вкусные роллы приезжали к вам без задержек. Но от внештатных ситуаций, к сожалению никто не застрахован.\n\nЕсли курьер опаздывает, пожалуйста, свяжитесь с нашим call-центром: 8 (863) 333-50-50. Мы обязательно разберемся в сложившейся ситуации.',
        link: { href: 'tel:+78633335050', label: '8 (863) 333-50-50' },
      },
      {
        id: 'missing-items',
        question: 'Заказ доехал не полностью, что делать?',
        answer:
          'Если доставленный заказ лишь частично совпадает с тем, который вы оплатили, незамедлительно сообщите нам об этом по телефону 8 (863) 333-50-50. Мы доставим недостающую часть заказа или компенсируем ее.\n\nВажно: свяжитесь с нашим call-центром не позднее 10 минут с момента получения заказа.',
        link: { href: 'tel:+78633335050', label: '8 (863) 333-50-50' },
      },
    ],
  },
  {
    id: 'promotions',
    title: 'Акции и скидки',
    questions: [
      {
        id: 'discounts',
        question: 'Какие акции сейчас действуют?',
        answer:
          'У нас всегда действуют несколько выгодных акций: статусные роллы, рулетка с подарками, подарок за первый заказ, ролл за отзыв. Подробности по каждой акции вы можете узнать на нашем сайте в разделе «Акции».',
        link: { href: '/actions', label: 'Посмотреть акции' },
      },
      {
        id: 'roulette',
        question: 'Как воспользоваться рулеткой с подарками?',
        answer:
          'В меню на главной есть карточка «Рулетка» с фирменной коробкой. Откройте её и нажмите «Крутить» — рулетка выберет один из 8 роллов, и он сразу попадёт в корзину за 199 ₽.\n\nВ одном заказе — один ролл из рулетки. Рулетка не суммируется с «Сетом дня».',
        link: { href: '/actions', label: 'Условия акций' },
      },
      {
        id: 'promo-codes',
        question: 'У меня есть промокод, как его применить?',
        answer:
          'Используйте промокод в специальном окне в момент оформления заказа, или укажите его в комментариях к заказу.',
      },
      {
        id: 'where-promo',
        question: 'Где брать актуальные промокоды и узнавать о новых акциях?',
        answer:
          'Информация о бонусах и горячих предложениях доступна участникам секретного чата. Присоединяйтесь в наше сообщество ВКонтакте!',
        link: { href: 'https://vk.com/aziatochka_ru', label: 'Сообщество ВКонтакте' },
      },
      // Вопрос про День рождения убран вместе со скрытием самой акции.
    ],
  },
  {
    id: 'product',
    title: 'О продукции',
    questions: [
      {
        id: 'dislike',
        question: 'Мне не понравились роллы, что делать?',
        answer:
          'Чтобы оценить качество приготовленных роллов, нам потребуется возврат порции в количестве не менее 80%. Шеф проведет экспертизу, приготовит новую порцию и мы отправим ее вам повторно.\n\nВажно:\n— срок приготовления определяется текущей плотностью заказов;\n— расчет времени на доставку обменных блюд не производится;\n— вкусовые предпочтения не являются уважительной причиной для возврата продукта, только блюдо ненадлежащего качества.',
      },
      {
        id: 'cold-rolls',
        question: 'Горячие роллы — не горячие. Почему?',
        answer:
          'Горячие роллы — это способ приготовления, но не вариант подачи. Мы используем небольшую температурную нагрузку лишь для того, чтобы сформировать шапочки на запеченных роллах, и корочку — на темпурных. Сам ролл и начинка должны оставаться холодными.',
      },
      {
        id: 'rolls-in-soy',
        question: 'Ролл развалился в соевом соусе. Почему?',
        answer:
          'Классическая церемония поедания роллов не предполагает их замачивания в соевом соусе. Воздушный рисовый рулетик при намокании и физическом воздействии бамбуковых палочек распадается, руководствуясь принципами физики. Чтобы избежать подобных казусов, лишь слегка обмакните ролл в соус, чтобы оттенить и дополнить вкус.',
      },
      {
        id: 'uneven-cuts',
        question: 'Роллы порезаны неровно. Почему?',
        answer:
          'Наши сушисты хоть и огромные профессионалы, но все человеческое им тоже не чуждо. Ручной, а не механический труд, допускает погрешность в нарезке. Если один кусочек на пару миллиметров толще другого, не сомневайтесь — он такой же вкусный!',
      },
      {
        id: 'small-size',
        question: 'Роллы как будто маленькие... Это так?',
        answer:
          'Мы работаем по внутренним регламентам компании, а также со строгим соблюдением граммовок, указанных в технологической карте конкретного блюда. Итоговый вес продукта указан в нашем меню. Пожалуйста, будьте внимательны, оформляя заказ!',
      },
    ],
  },
  {
    id: 'other',
    title: 'Прочее',
    questions: [
      {
        id: 'allergens',
        question: 'Про аллергены',
        answer:
          'Все наши продукты могут содержать следующие аллергены:\n\n— рыба и продукты ее переработки;\n— ракообразные и продукты их переработки;\n— моллюски и продукты их переработки;\n— арахис и продукты его переработки;\n— горчица и продукты ее переработки;\n— кунжут и продукты их переработки;\n— молоко и продукты их переработки (в том числе лактоза);\n— яйца и продукты их переработки;\n— некоторые фрукты и ягоды;\n— орехи и продукты их переработки;\n— мясо курицы;\n— злаки, содержащие глютен, и продукты их переработки;\n— мед.\n\nПожалуйста, убедитесь в отсутствии противопоказаний, оформляя заказ!',
      },
      {
        id: 'why-better',
        question: 'Почему стоит попробовать ваши роллы?',
        answer:
          '«Азиаточка» — сервис быстрой доставки вкусных роллов. Наши роллы спасают, когда хочется перекусить.\n\nНаши роллы — это баланс вкуса и пользы:\n— сочный рис с правильной заправкой — база;\n— больше морепродуктов, овощей и фруктов;\n— «та самая» нарезка и впечатляющая подача.',
      },
      {
        id: 'management',
        question: 'У меня есть вопрос к руководству, как связаться?',
        answer:
          'Будьте уверены, что любое ваше предложение, адресованное нашему руководителю, обязательно будет передано ему. Оставьте свой вопрос оператору нашего call-центра: 8 (863) 333-50-50.',
        link: { href: 'tel:+78633335050', label: '8 (863) 333-50-50' },
      },
      {
        id: 'refund',
        question: 'Заказ отменен, как вернуть деньги?',
        answer:
          'Возврат денежных средств осуществляется в рамках внутренних правил вашего банка и обычно занимает до 10 рабочих дней.',
      },
    ],
  },
];
